export const arrangementI18n = {
  arrangement: {
    en: {
      ADD_NEW: 'Add new',
      AGREEMENT_EXISTS: 'Agreement Exists',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Are you sure you want to delete?',
      BASIC_INFORMATION: 'Basic information',
      BUSINESS_ENTITIES: 'Business entities',
      BUSINESS_ENTITY: 'Business entity',
      CARE_COST_PER_DAY: 'Care cost per day',
      CLIENT: 'Client',
      CLIENT_OBFUSCATED_ON_TERMINATION: 'Obfuscating client on termination',
      COST_REIMBURSEMENT_PER_DAY: 'Overhead per day',
      COST_REIMBURSEMENT_PER_MONTH: 'Overhead per month',
      CREATE: 'Create',
      CREATE_FAILED: 'Create failed',
      CREATE_FRAMEWORK_AGREEMENT: 'Create framework agreement',
      CREATE_NEW_BUSINESS_ENTITY: 'Create new business entity',
      CREATE_NEW_PLACEMENT_TYPE: 'Create new placement type',
      CREATED: 'Created',
      CREATED_AT: 'Created {{date}}',
      CREATED_SUCCESSFULLY: 'Created',
      CUSTOMER: 'Customer',
      DAILY_PRICE: 'Daily price',
      DELETE_FAILED: 'Delete failed',
      DELETED: 'Deleted',
      EDIT: 'Edit {{name}}',
      EDIT_FRAMEWORK_AGREEMENT: 'Edit framework agreement',
      END_DATE: 'End Date',
      FEMALE: 'Female',
      FILTER: 'Filter',
      FILTER_FRAMEWORK_AGREEMENTS_DESCRIPTION:
        'Filter by specified criteria to find what you are looking for.',
      FOSTER_FAMILY: 'Foster Family',
      FRAMEWORK_AGREEMENT: 'Framework agreement',
      FRAMEWORK_AGREEMENTS: 'Framework agreements',
      GENDER: 'Gender',
      ID: 'ID',
      MALE: 'Male',
      MANAGERS: 'Managers',
      MUNICIPALITIES: 'Municipalities',
      NO: 'No',
      NOTHING_TO_SHOW: 'Nothing to show',
      OBFUSCATE_CLIENT_ON_TERMINATION: 'Obfuscate client on termination',
      OTHER_INFO: 'Other Info',
      PLACEMENT_CHARACTER: 'Placement Character',
      PLACEMENT_DATE: 'Placement Date',
      PLACEMENT_INTERVAL: 'Placement Interval',
      PLACEMENT_TYPE: 'Placement type',
      PLACEMENT_TYPES: 'Placement types',
      PRICES: 'Prices',
      PURPOSE_OF_INSERTION: 'Purpose of Insertion',
      REASON_FOR_INSERTION: 'Reason for Insertion',
      RESPONSIBLE: 'Responsible',
      SALARY_PER_DAY: 'Salary per day',
      SALARY_PER_MONTH: 'Salary per month',
      SAVE: 'Save',
      SOCIAL_SECURITY_NUMBER: 'Social Security Number',
      TERMINATION_COMMENT: 'Termination comment',
      TERMINATION_REASON: 'Termination Reason',
      TITLE: 'Title',
      TYPE_OF_INSERTION: 'Type of Insertion',
      UPDATE_FAILED: 'Update failed',
      UPDATED: 'Updated',
      UPDATED_SUCCESSFULLY: 'Updated',
      YES: 'Yes',
      YOU_HAVE_ADDED_ALL_PLACEMENT_TYPES:
        'You have added all placement types to the framework agreement. You cannot add more. You can edit the prices for the existing placement types.',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE:
        'Your changes will be irreversible and cannot be undone',
    },
    'sv-SE': {
      ADD_NEW: 'Lägg till ny',
      AGREEMENT_EXISTS: 'Avtal Finns',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Är du säker på att du vill radera?',
      BASIC_INFORMATION: 'Grunduppgifter',
      BUSINESS_ENTITIES: 'Affärsenheter',
      BUSINESS_ENTITY: 'Affärsenhet',
      CARE_COST_PER_DAY: 'Vårdkostnad per dag',
      CLIENT: 'Klient',
      CLIENT_OBFUSCATED_ON_TERMINATION: 'Klienten gallras vid avslut',
      COST_REIMBURSEMENT_PER_DAY: 'Omkostnadsersättning per dag',
      COST_REIMBURSEMENT_PER_MONTH: 'Omkostnadsersättning per månad',
      CREATE: 'Skapa',
      CREATE_FAILED: 'Skapande misslyckades',
      CREATE_FRAMEWORK_AGREEMENT: 'Skapa ramavtal',
      CREATE_NEW_BUSINESS_ENTITY: 'Skapa ny affärsenhet',
      CREATE_NEW_PLACEMENT_TYPE: 'Skapa ny placeringstyp',
      CREATED: 'Skapad',
      CREATED_AT: 'Skapad {{date}}',
      CREATED_SUCCESSFULLY: 'Skapad',
      CUSTOMER: 'Kund',
      DAILY_PRICE: 'Dagligt pris',
      DELETE: 'Ta bort',
      DELETE_ENTITY_DESCRIPTION:
        'Är du säker på att du vill ta bort denna enhet?',
      DELETE_FAILED: 'Radering misslyckades',
      DELETED: 'Raderad',
      EDIT: 'Redigera {{name}}',
      EDIT_FRAMEWORK_AGREEMENT: 'Redigera ramavtal',
      END_DATE: 'Slutdatum',
      FEMALE: 'Kvinna',
      FILTER: 'Filtrera',
      FILTER_FRAMEWORK_AGREEMENTS_DESCRIPTION:
        'Filtrera efter angivna kriterier för att hitta det du letar efter.',
      FOSTER_FAMILY: 'Familjehem',
      FRAMEWORK_AGREEMENT: 'Ramavtal',
      FRAMEWORK_AGREEMENTS: 'Ramavtal',
      GENDER: 'Kön',
      ID: 'ID',
      MALE: 'Man',
      MANAGERS: 'Handläggare',
      MUNICIPALITIES: 'Kommuner',
      NO: 'Nej',
      NOTHING_TO_SHOW: 'Inget att visa',
      OBFUSCATE_CLIENT_ON_TERMINATION: 'Gallra klient vid avslut',
      OTHER_INFO: 'Övrig Information',
      PLACEMENT_CHARACTER: 'Placeringsegenskap',
      PLACEMENT_DATE: 'Placeringsdatum',
      PLACEMENT_INTERVAL: 'Placeringstid',
      PLACEMENT_TYPE: 'Placeringstyp',
      PLACEMENT_TYPES: 'Placeringstyper',
      PRICES: 'Priser',
      PURPOSE_OF_INSERTION: 'Syfte med Placering',
      REASON_FOR_INSERTION: 'Anledning till Placering',
      RESPONSIBLE: 'Ansvarig',
      SALARY_PER_DAY: 'Lön per dag',
      SALARY_PER_MONTH: 'Lön per månad',
      SAVE: 'Spara',
      SOCIAL_SECURITY_NUMBER: 'Personnummer',
      TERMINATION_COMMENT: 'Avslutskommentar',
      TERMINATION_REASON: 'Avslutningsorsak',
      TITLE: 'Titel',
      TYPE_OF_INSERTION: 'Typ av Placering',
      UPDATE_FAILED: 'Uppdatering misslyckades',
      UPDATED: 'Uppdaterad',
      UPDATED_SUCCESSFULLY: 'Uppdaterad',
      YES: 'Ja',
      YOU_HAVE_ADDED_ALL_PLACEMENT_TYPES:
        'Du har lagt till alla placeringstyper i ramavtalet. Det går inte att lägga till fler. Du kan redigera priserna för de befintliga placeringstyperna.',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE:
        'Dina ändringar kommer att vara oåterkalleliga och kan inte ångras',
    },
  },
};
